import { render, staticRenderFns } from "./LivePublishPolicy.vue?vue&type=template&id=5a57696c&scoped=true"
import script from "./LivePublishPolicy.vue?vue&type=script&lang=js"
export * from "./LivePublishPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a57696c",
  null
  
)

export default component.exports